import { paths } from '@/configs/paths'
// import { useAppStore } from '@/stores'
import { Navigate } from 'react-router-dom'
import { useMemo } from 'react'
import { ROLES } from '@/constants/common'
import { getCurrentRole } from '@/utils/auth'

export const UserLanding = () => {
  // const userRole = useAppStore((state) => state.user?.role)
  const userRole = getCurrentRole()

  const targetPath = useMemo(() => {
    switch (userRole) {
      case ROLES.DISTRIBUTOR_ADMIN:
        return paths.inStock.path

      case ROLES.CUSTOMER_ADMIN:
        return paths.deliveries.path

      case ROLES.CUSTOMER_STAFF:
        return paths.stockersList.path

      case ROLES.DELIVERY_STAFF:
        return paths.outboundList.path

      case ROLES.SYSTEM:
        return paths.distributorManage.path

      default:
        return paths.inStock.path
    }
  }, [userRole])

  if (!userRole) {
    localStorage.clear()
    return <Navigate to={paths.login.path} replace />
  }

  return <Navigate to={targetPath} replace />
}

export default UserLanding
